angular.module('rjmNg.filters').filter "encodeURIComponent", [
  "$window"
  (
    $window
  ) ->
    (value) ->
      if value?
        $window.encodeURIComponent(value)
]
